<script>
import TitleWithRow from '@/components(new)/UI/Typography/TitleWithRow/TitleWithRow.vue'
import Label from '@/components(new)/UI/Forms/Label/Label.vue'
import InputSelect from '@/components(new)/UI/Forms/InputSelect/InputSelect.vue'
import Card from '@/components(new)/UI/Cards/Card/Card.vue'
import { formataStringYearMonthToBr } from '@/libs/utils/functions/dataFormater'

export default {
  components: {
    TitleWithRow,
    Label,
    InputSelect,
    Card
  },
  props: {
    nomeAba: {
      type: String,
      required: true
    },
    pratica: {
      type: Object,
      required: true
    },
    // validação dos campos para as práticas SPDG e SPDH
    praticasArray: {
      typeof: Array,
      require: false,
      default: null
    }
  },
  data () {
    return {
      forms: {
        cultura: '',
        previsaoColheita: '',
        produtividade: ''
      },
      opcoesCultura: [
        {id: 'SOJA', nome: 'Soja'},
        {id: 'MILHO', nome: 'Milho'},
        {id: 'FEIJAO', nome: 'Feijão'},
        {id: 'SORGO', nome: 'Sorgo'}
      ]
    }
  },
  computed: {
    disableButton () {
      return !(this.forms.cultura && this.forms.previsaoColheita && this.forms.produtividade)
    },
    rules () {
      return !this.praticasArray ? !this.pratica.previsoesColheitaProdutividade.length ? 'required' : ''
        : !this.pratica.previsoesColheitaProdutividade.length && !this.praticasArray.length ? 'required' : ''
    }
  },
  methods: {
    formataStringYearMonthToBr,
    btnAdicionar () {
      this.pratica.previsoesColheitaProdutividade.push({
        ...this.forms
      })
      this.forms = {
        cultura: '',
        previsaoColheita: '',
        produtividade: ''
      }
    },
    btnApagar (index) {
      this.pratica.previsoesColheitaProdutividade.splice(index, 1)
    },
    getNomeCultura (cultura) {
      const culturaSelecionada = this.opcoesCultura.filter(a => a.id === cultura)
      return culturaSelecionada[0].nome
    }
  }
}
</script>

<template>
  <div>
    <TitleWithRow
      title="Previsão de colheita e produtividade (mês e ano/ sacas por hectare)"
    />
    <el-row>
      <InputSelect
        label="Cultura"
        :nomeAba="nomeAba"
        :opcoes="opcoesCultura"
        :widthColumn="5"
        v-model="forms.cultura"
        :obrigatorio="true"
        :rulesInput="rules"
      />
      <validation-provider
        :rules="rules" v-slot="{ errors }"
        :name="nomeAba + 'Previsão de colheita (mês/ano)'"
      >
        <el-col :span="7" class="ml-2">
          <Label label="Previsão de colheita (mês/ano)" :obrigatorio="true" />
          <el-date-picker
            type="month"
            placeholder="Selecione mês e ano"
            format="MM/yyyy"
            value-format="yyyy-MM-dd"
            style="width: 100%"
            v-model="forms.previsaoColheita"
            :class="{'input erro' : errors.length}"
          />
          <span class="help erro">{{ errors[0] }}</span>
        </el-col>
      </validation-provider>

      <validation-provider
        :rules="rules"
        v-slot="{ errors }"
        mode="lazy"
        :name="`${nomeAba}/Produtividade por hectare`"
      >
        <el-col :span="6" style="margin-left: 1rem;">
          <Label label="Produtividade por hectare" :obrigatorio="true" />
          <el-input
            name="Produtividade por hectare"
            placeholder="sacas/hectare"
            v-model="forms.produtividade"
            :class="{'input erro' : errors.length}"
          />
          <span class="help erro"> {{ errors[0] }}</span>
        </el-col>
      </validation-provider>
      <el-col :span="4" class="ml-3">
        <div class="mb-1">&nbsp;</div>
        <el-button
          :disabled="disableButton"
          round type="primary"
          @click="btnAdicionar()"
        >
          Adicionar
        </el-button>
      </el-col>
    </el-row>

    <el-row :gutter="20" v-if="pratica.previsoesColheitaProdutividade.length > 0">
      <div class="flex-wrapper row mt-3">
        <div v-for="(e, i) in pratica.previsoesColheitaProdutividade" :key="i+e.cultura">
          <Card
            :objeto="{
              cultura: getNomeCultura(e.cultura),
              previsaoColheita: formataStringYearMonthToBr(e.previsaoColheita),
              produtividade: e.produtividade + ' sacas/hectares'
            }"
            :deletar="() => btnApagar(i)"
            titulo="Previsão de colheita e produtividade"
          />
        </div>
      </div>
    </el-row>
  </div>
</template>



// WEBPACK FOOTER //
// src/components(new)/UI/Forms/FormulariosProntos/PrevisaoColheita/PrevisaoColheita.vue